export default __webpack_public_path__ + "static/media/unitsofstudy.9ea8e116.svg";